<template>
<svg xmlns="http://www.w3.org/2000/svg" width="9.699" height="7.454" viewBox="0 0 9.699 7.454">
  <defs>
    <clipPath id="a">
      <path data-name="Rectangle 24" d="M0 0h9.699v7.454H0z"/>
    </clipPath>
  </defs>
  <g data-name="Group 23" clip-path="url(#a)">
    <path data-name="Path 104" d="M8.662.064A.229.229 0 0 1 8.831 0a.31.31 0 0 1 .191.064l.593.614A.2.2 0 0 1 9.7.847a.263.263 0 0 1-.085.191L3.261 7.391a.229.229 0 0 1-.169.064.31.31 0 0 1-.192-.064L.085 4.553A.2.2 0 0 1 0 4.384a.263.263 0 0 1 .085-.191L.678 3.6a.264.264 0 0 1 .191-.085.2.2 0 0 1 .169.085l2.054 2.054Z" />
  </g>
</svg>
</template>